export enum IndicatorStatus {
    ACTIVE = 'ACTIVE',
    DEGRADED = 'DEGRADED',
    INACTIVE = 'INACTIVE',
    UNKNOWN = 'UNKNOWN',
}
